import React from "react";
import { UserSettingsLoaderTemplate } from "themes/administration/user/components";

function UserSettingsLoader(props) {
    return <UserSettingsLoaderTemplate {...props} />;
}

export default UserSettingsLoader;
